import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Modal, Form, Input, message } from 'antd';
import auth from '../../services/auth';
import { fetchPost } from '../../utils/request';
import styles from './Index.less';
import { history } from '../../utils/config'

@Form.create()

class Header extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      menus: [],
      activeModule: '',
      pwdDlgVisible: false
    }
  }

  componentWillReceiveProps (props) {
    if (!this.state.menus.length) {
      let clickActiveModule = sessionStorage.getItem('clickActiveModule')
      if (clickActiveModule) {
        this.setState({
          menus: props.menus || [],
          activeModule: clickActiveModule
        })
      } else {
        this.setState({
          menus: props.menus || [],
          activeModule: props.menus[0].parentName
        })
      }
    }
  }

  isSimplePwd = (rule, value, callback) => {
    if (!value) {
      callback();
    }
    if (value.length < 6) {
      callback();
      return 0;
    }
    let ls = 0;
    if (value.match(/([a-z])+/)) {
      ls++;
    }
    if (value.match(/([0-9])+/)) {
      ls++;
    }
    if (value.match(/([A-Z])+/)) {
      ls++;
    }
    if(value.match(/[^a-zA-Z0-9]+/)){
			ls++;
    }
    if (ls < 3) {
      callback('请输入6位以上密码，且包含数字、小写字母、大写字母及特殊字符中的三种');
    }
    else {
      callback();
    }
  }

  handleChangePwd(visible) {
    this.setState({
      pwdDlgVisible: visible
    }, () => this.props.form.resetFields());
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.handleChangePwd(false);
        fetchPost('/staff/pwd/update', values).then(json => {
          message.info(json.msg);
          auth.logout();
        });
      }
    })
  }

  render () {
    let { pwdDlgVisible } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formLayout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 17 }
    };
    return (
      <div className={styles.headerWrapper}>
        <div onClick={this.handleClick}
          style={{
            minWidth: '160px',
            height: '48px',
            float: 'left',
            lineHeight: '48px',
            paddingLeft: '22px'
          }}
        >
        </div>

        <div className={styles.tabs} />

        <div className={styles.user}>
          <Menu
            mode='horizontal'
            className={styles.headNav}
          >
            <Menu.Item className={` ${styles.pl10} ${styles.introNone}`}>
              <span>
                <Icon type='user' />
               欢迎您,
                {
                  auth.getUserName()
                }
              </span>
            </Menu.Item>
            <Menu.Item className={` ${styles.pl10} ${styles.introNone}`}>
              <span onClick={e => {
                this.handleChangePwd(true)
              }}>
                <Icon type="edit" />
                修改密码
              </span>
            </Menu.Item>
            <Menu.Item className={` ${styles.pl10} ${styles.introNone}`}>
              <span onClick={e => {
                auth.logout()
              }}>
                <Icon type='logout' />
                登出
              </span>
            </Menu.Item>

          </Menu>
        </div>
        <Modal
          title="修改密码"
          visible={pwdDlgVisible}
          onOk={this.handleSubmit}
          onCancel={(e) => { this.handleChangePwd(false) }}
          width="400px"
          >
            <Form>
              <Form.Item {...formLayout}
                label="密码"
                name="password"
                >
                  {
                    getFieldDecorator('password', {
                      rules: [{
                        required: true, message: '请输入新密码'
                      }, {
                        validator: this.isSimplePwd,
                      }]
                    })(
                      <Input type="password" placeholder="请输入新密码" />
                    )
                  }
                </Form.Item>
            </Form>
        </Modal>
      </div>
    )
  }
}

export default Header



/** WEBPACK FOOTER **
 ** ./src/components/homePage/HeaderMenu.js
 **/